// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page-specific styles for About */

/* Account and management */
.delivery-list {
  display: grid;
  gap: 0.8rem;
}
.delivery-card {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
}
.delivery-card > img {
  width: 76px;
  height: 90px;
  flex: 0 0 auto;
  object-fit: cover;
  border-radius: 14px;
}
.delivery-card h3 {
  font-family: var(--font-serif);
  font-size: 1.2rem;
}
.detail-status {
  padding: 1.5rem;
  border-radius: var(--radius);
  color: white;
  background: var(--green-950);
  margin-bottom: 1rem;
}
.detail-status h2 {
  margin: 0.7rem 0 0.3rem;
}
.detail-status p {
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}
.action-list {
  overflow: hidden;
  margin-top: 1rem;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
}
.action-list a,
.action-list button {
  width: 100%;
  min-height: 58px;
  padding: 0 1rem;
  display: grid;
  grid-template-columns: 28px 1fr auto;
  align-items: center;
  text-align: left;
  border: 0;
  border-bottom: 1px solid var(--line);
  color: var(--ink);
  background: transparent;
  text-decoration: none;
  font-size: 0.88rem;
  font-weight: 700;
}
.action-list > :last-child {
  border-bottom: 0;
}
.action-list a > i:first-child,
.action-list button > i:first-child {
  color: var(--green-700);
}
.action-list i:last-child {
  color: #abb4ad;
  font-size: 0.7rem;
}
.modal-content {
  border: 0;
  border-radius: var(--radius);
}
.modal-icon {
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  margin: 0 auto 1rem;
  border-radius: 50%;
  color: var(--green-700);
  background: var(--green-50);
}
.subscription-hero,
.profile-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  border-radius: var(--radius);
  color: white;
  background: var(--green-950);
}
.subscription-hero h2,
.profile-card h2 {
  margin: 0.6rem 0 0.2rem;
  font-size: 1.4rem;
}
.subscription-hero p,
.profile-card p {
  margin: 0;
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.8rem;
}
.profile-card .icon-button {
  margin-left: auto;
  color: white;
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.1);
}
.avatar {
  width: 62px;
  height: 62px;
  display: grid;
  place-items: center;
  border-radius: 18px;
  color: var(--green-950);
  background: var(--yellow);
  font-family: var(--font-serif);
  font-size: 1.7rem;
}
.notification-list {
  display: grid;
  gap: 0.7rem;
}
.notification-list article {
  display: flex;
  gap: 0.8rem;
  padding: 1rem;
  border: 1px solid var(--line);
  border-radius: 16px;
  background: var(--paper);
}
.notification-list article.unread {
  border-color: #b9d8c4;
  background: var(--green-50);
}
.notification-list article > span {
  width: 40px;
  height: 40px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: var(--green-700);
  background: var(--green-100);
}
.notification-list article > div {
  flex: 1;
}
.notification-list h3 {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 800;
}
.notification-list p {
  margin: 0.25rem 0 0;
  color: var(--muted);
  font-size: 0.8rem;
}
.notification-list small {
  color: var(--muted);
  font-size: 0.65rem;
}
.support-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.8rem;
  margin-bottom: 3rem;
}
.support-grid a {
  min-height: 130px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 18px;
  color: white;
  background: var(--green-800);
  text-decoration: none;
  font-weight: 700;
}
.support-grid i {
  font-size: 1.8rem;
  color: var(--yellow);
}
.accordion-item {
  border-color: var(--line);
  background: var(--paper);
}
.accordion-button {
  font-weight: 700;
  background: var(--paper);
  box-shadow: none !important;
}
.accordion-button:not(.collapsed) {
  color: var(--green-800);
  background: var(--green-50);
}
.about-hero {
  padding: 2rem 0;
  color: white;
  background: var(--green-950);
}
.about-hero .eyebrow {
  color: var(--yellow);
}
.about-hero h1 {
  font-size: clamp(3rem, 8vw, 6rem);
  max-width: 850px;
  margin: 0.5rem 0;
}
.about-hero p {
  max-width: 660px;
  color: rgba(255, 255, 255, 0.65);
  font-size: 1.1rem;
}
.about-copy {
  padding: 1rem 1rem;
  font-size: 1.1rem;
  line-height: 1.7;
}
.about-copy blockquote {
  margin: 2rem 0;
  color: var(--green-700);
  font-family: var(--font-serif);
  font-size: 2rem;
  line-height: 1.15;
}
.empty-state {
  padding: 3rem 1rem;
  text-align: center;
  border: 1px dashed var(--line);
  border-radius: var(--radius);
  background: var(--paper);
}
.empty-state > span {
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  margin: 0 auto 1rem;
  border-radius: 18px;
  color: var(--green-700);
  background: var(--green-50);
  font-size: 1.4rem;
}
.empty-state h2 {
  font-size: 1.5rem;
}
.empty-state p {
  color: var(--muted);
}
.skeleton-card {
  height: 220px;
  padding: 1rem;
  border-radius: var(--radius);
  background: var(--paper);
}
.skeleton-card div,
.skeleton-card span {
  display: block;
  border-radius: 8px;
  background: linear-gradient(90deg, #edf0ed, #f7f8f7, #edf0ed);
  background-size: 200%;
  animation: shimmer 1.4s infinite;
}
.skeleton-card div {
  height: 130px;
}
.skeleton-card span {
  height: 12px;
  margin-top: 0.8rem;
}
.skeleton-card span:last-child {
  width: 60%;
}
@keyframes shimmer {
  to {
    background-position: -200%;
  }
}

@media (min-width: 576px) {
  .next-delivery {
    flex-direction: row;
    align-items: center;
  }
  .build-basket {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .choice-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .success-card {
    padding: 2.5rem;
  }
}

@media (min-width: 768px) {
  .onboarding {
    grid-template-columns: 1.1fr 0.9fr;
    grid-template-rows: 100svh;
  }
  .onboarding-image {
    margin: 1.5rem;
  }
  .onboarding-copy {
    padding: 4rem;
  }
  .hero-actions {
    flex-direction: row;
  }
  .steps-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .benefit-grid {
    grid-template-columns: repeat(4, 1fr);
  }
  .market-banner div {
    padding: 2.5rem;
  }
  .detail-grid {
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
  .detail-image {
    position: sticky;
    top: 96px;
    height: calc(100vh - 130px);
  }
  .detail-copy {
    padding: 2rem 0;
  }
  .nutrition-grid {
    grid-template-columns: repeat(4, 1fr);
  }
  .delivery-card > img {
    width: 110px;
    height: 110px;
  }
  .about-copy {
    padding-top: 5rem;
  }
}

@media (min-width: 992px) {
  .desktop-nav {
    display: flex;
  }
  .profile-chip {
    display: flex;
  }
  .bottom-nav {
    display: none;
  }
  .with-nav {
    padding-bottom: 0;
  }
  .page-wrap {
    padding-top: 4rem;
  }
  .home-hero {
    padding: 5rem 0;
    min-height: 700px;
    display: flex;
    align-items: center;
  }
  .hero-visual {
    display: block;
  }
  .schedule-layout {
    grid-template-columns: minmax(0, 1fr) 330px;
    align-items: start;
  }
  .schedule-summary {
    position: sticky;
    top: 1.5rem;
  }
}

@media (min-width: 1200px) {
  .desktop-nav {
    gap: 0.5rem;
  }
  .home-hero h1 {
    font-size: 5.8rem;
  }
}

@media (min-width: 768px) {
  .delivery-card > img {
    width: 110px;
    height: 110px;
  }
  .about-copy {
    padding-top: 5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/About.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC,2BAA2B;AAC3B;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,+BAA+B;EAC/B,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;;EAEE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,oCAAoC;EACpC,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;AAC9B;AACA;;EAEE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;;EAEE,SAAS;EACT,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,sCAAsC;EACtC,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,OAAO;AACT;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,6DAA6D;EAC7D,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,2CAA2C;IAC3C,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Page-specific styles for About */\n\n/* Account and management */\n.delivery-list {\n  display: grid;\n  gap: 0.8rem;\n}\n.delivery-card {\n  display: flex;\n  gap: 1rem;\n  padding: 1rem;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.delivery-card > img {\n  width: 76px;\n  height: 90px;\n  flex: 0 0 auto;\n  object-fit: cover;\n  border-radius: 14px;\n}\n.delivery-card h3 {\n  font-family: var(--font-serif);\n  font-size: 1.2rem;\n}\n.detail-status {\n  padding: 1.5rem;\n  border-radius: var(--radius);\n  color: white;\n  background: var(--green-950);\n  margin-bottom: 1rem;\n}\n.detail-status h2 {\n  margin: 0.7rem 0 0.3rem;\n}\n.detail-status p {\n  color: rgba(255, 255, 255, 0.6);\n  margin: 0;\n}\n.action-list {\n  overflow: hidden;\n  margin-top: 1rem;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.action-list a,\n.action-list button {\n  width: 100%;\n  min-height: 58px;\n  padding: 0 1rem;\n  display: grid;\n  grid-template-columns: 28px 1fr auto;\n  align-items: center;\n  text-align: left;\n  border: 0;\n  border-bottom: 1px solid var(--line);\n  color: var(--ink);\n  background: transparent;\n  text-decoration: none;\n  font-size: 0.88rem;\n  font-weight: 700;\n}\n.action-list > :last-child {\n  border-bottom: 0;\n}\n.action-list a > i:first-child,\n.action-list button > i:first-child {\n  color: var(--green-700);\n}\n.action-list i:last-child {\n  color: #abb4ad;\n  font-size: 0.7rem;\n}\n.modal-content {\n  border: 0;\n  border-radius: var(--radius);\n}\n.modal-icon {\n  width: 64px;\n  height: 64px;\n  display: grid;\n  place-items: center;\n  margin: 0 auto 1rem;\n  border-radius: 50%;\n  color: var(--green-700);\n  background: var(--green-50);\n}\n.subscription-hero,\n.profile-card {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.25rem;\n  border-radius: var(--radius);\n  color: white;\n  background: var(--green-950);\n}\n.subscription-hero h2,\n.profile-card h2 {\n  margin: 0.6rem 0 0.2rem;\n  font-size: 1.4rem;\n}\n.subscription-hero p,\n.profile-card p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.65);\n  font-size: 0.8rem;\n}\n.profile-card .icon-button {\n  margin-left: auto;\n  color: white;\n  border-color: rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.1);\n}\n.avatar {\n  width: 62px;\n  height: 62px;\n  display: grid;\n  place-items: center;\n  border-radius: 18px;\n  color: var(--green-950);\n  background: var(--yellow);\n  font-family: var(--font-serif);\n  font-size: 1.7rem;\n}\n.notification-list {\n  display: grid;\n  gap: 0.7rem;\n}\n.notification-list article {\n  display: flex;\n  gap: 0.8rem;\n  padding: 1rem;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  background: var(--paper);\n}\n.notification-list article.unread {\n  border-color: #b9d8c4;\n  background: var(--green-50);\n}\n.notification-list article > span {\n  width: 40px;\n  height: 40px;\n  flex: 0 0 auto;\n  display: grid;\n  place-items: center;\n  border-radius: 12px;\n  color: var(--green-700);\n  background: var(--green-100);\n}\n.notification-list article > div {\n  flex: 1;\n}\n.notification-list h3 {\n  margin: 0;\n  font-size: 0.9rem;\n  font-weight: 800;\n}\n.notification-list p {\n  margin: 0.25rem 0 0;\n  color: var(--muted);\n  font-size: 0.8rem;\n}\n.notification-list small {\n  color: var(--muted);\n  font-size: 0.65rem;\n}\n.support-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.8rem;\n  margin-bottom: 3rem;\n}\n.support-grid a {\n  min-height: 130px;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border-radius: 18px;\n  color: white;\n  background: var(--green-800);\n  text-decoration: none;\n  font-weight: 700;\n}\n.support-grid i {\n  font-size: 1.8rem;\n  color: var(--yellow);\n}\n.accordion-item {\n  border-color: var(--line);\n  background: var(--paper);\n}\n.accordion-button {\n  font-weight: 700;\n  background: var(--paper);\n  box-shadow: none !important;\n}\n.accordion-button:not(.collapsed) {\n  color: var(--green-800);\n  background: var(--green-50);\n}\n.about-hero {\n  padding: 2rem 0;\n  color: white;\n  background: var(--green-950);\n}\n.about-hero .eyebrow {\n  color: var(--yellow);\n}\n.about-hero h1 {\n  font-size: clamp(3rem, 8vw, 6rem);\n  max-width: 850px;\n  margin: 0.5rem 0;\n}\n.about-hero p {\n  max-width: 660px;\n  color: rgba(255, 255, 255, 0.65);\n  font-size: 1.1rem;\n}\n.about-copy {\n  padding: 1rem 1rem;\n  font-size: 1.1rem;\n  line-height: 1.7;\n}\n.about-copy blockquote {\n  margin: 2rem 0;\n  color: var(--green-700);\n  font-family: var(--font-serif);\n  font-size: 2rem;\n  line-height: 1.15;\n}\n.empty-state {\n  padding: 3rem 1rem;\n  text-align: center;\n  border: 1px dashed var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.empty-state > span {\n  width: 64px;\n  height: 64px;\n  display: grid;\n  place-items: center;\n  margin: 0 auto 1rem;\n  border-radius: 18px;\n  color: var(--green-700);\n  background: var(--green-50);\n  font-size: 1.4rem;\n}\n.empty-state h2 {\n  font-size: 1.5rem;\n}\n.empty-state p {\n  color: var(--muted);\n}\n.skeleton-card {\n  height: 220px;\n  padding: 1rem;\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.skeleton-card div,\n.skeleton-card span {\n  display: block;\n  border-radius: 8px;\n  background: linear-gradient(90deg, #edf0ed, #f7f8f7, #edf0ed);\n  background-size: 200%;\n  animation: shimmer 1.4s infinite;\n}\n.skeleton-card div {\n  height: 130px;\n}\n.skeleton-card span {\n  height: 12px;\n  margin-top: 0.8rem;\n}\n.skeleton-card span:last-child {\n  width: 60%;\n}\n@keyframes shimmer {\n  to {\n    background-position: -200%;\n  }\n}\n\n@media (min-width: 576px) {\n  .next-delivery {\n    flex-direction: row;\n    align-items: center;\n  }\n  .build-basket {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .choice-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .success-card {\n    padding: 2.5rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .onboarding {\n    grid-template-columns: 1.1fr 0.9fr;\n    grid-template-rows: 100svh;\n  }\n  .onboarding-image {\n    margin: 1.5rem;\n  }\n  .onboarding-copy {\n    padding: 4rem;\n  }\n  .hero-actions {\n    flex-direction: row;\n  }\n  .steps-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .benefit-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  .market-banner div {\n    padding: 2.5rem;\n  }\n  .detail-grid {\n    grid-template-columns: 1fr 1fr;\n    align-items: start;\n  }\n  .detail-image {\n    position: sticky;\n    top: 96px;\n    height: calc(100vh - 130px);\n  }\n  .detail-copy {\n    padding: 2rem 0;\n  }\n  .nutrition-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  .delivery-card > img {\n    width: 110px;\n    height: 110px;\n  }\n  .about-copy {\n    padding-top: 5rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .desktop-nav {\n    display: flex;\n  }\n  .profile-chip {\n    display: flex;\n  }\n  .bottom-nav {\n    display: none;\n  }\n  .with-nav {\n    padding-bottom: 0;\n  }\n  .page-wrap {\n    padding-top: 4rem;\n  }\n  .home-hero {\n    padding: 5rem 0;\n    min-height: 700px;\n    display: flex;\n    align-items: center;\n  }\n  .hero-visual {\n    display: block;\n  }\n  .schedule-layout {\n    grid-template-columns: minmax(0, 1fr) 330px;\n    align-items: start;\n  }\n  .schedule-summary {\n    position: sticky;\n    top: 1.5rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .desktop-nav {\n    gap: 0.5rem;\n  }\n  .home-hero h1 {\n    font-size: 5.8rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .delivery-card > img {\n    width: 110px;\n    height: 110px;\n  }\n  .about-copy {\n    padding-top: 5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
